<template>
  <div>
    <v-container grid-list-xs>
      <v-card
        hover
        min-height="300"
        width="500"
        height="400"
        class="mx-auto mt-10"
      >
        <v-card-title primary-title>
          Login Form
        </v-card-title>
        <v-card flat class="d-flex flex-column justify-end" height="300">
          <v-card-text>
            <v-form v-model="isValid" ref="loginForm">
              <v-text-field
                @keyup.native.enter="OnLogIn"
                autofocus
                prepend-icon="mdi-account-circle"
                name="UserNameTextFild"
                label="User Name"
                id="UserID"
                :rules="[v => !!v || 'User Name is require']"
                v-model.trim="LoginUser.UserName"
              ></v-text-field>
              <v-text-field
                @keyup.native.enter="OnLogIn"
                v-model="LoginUser.Password"
                prepend-icon="mdi-lock"
                name="PasswordTextFild"
                label="Password"
                id="PasswordId"
                :rules="[v => !!v || 'Password is require']"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!isValid"
                  width="100"
                  color="success"
                  dark
                  :loading="clicked"
                  @click="OnLogIn"
                  >Log In
                  <v-icon right>mdi-login</v-icon>
                </v-btn>
              </v-card-actions>
              <p class="red--text d-flex mt-2 justify-center">
                {{ msg }}
              </p>
            </v-form>
          </v-card-text>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPassword: false,
      isValid: false,
      clicked: false,
      msg: "",
      LoginUser: {
        UserName: "",
        Password: "",
      },
    };
  },
  methods: {
    OnLogIn() {
      if (this.$refs.loginForm.validate()) {
        this.clicked = true;
        this.msg = "";
        this.$store
          .dispatch("login", this.LoginUser)
          .then(() => {
            this.clicked = false;
          })
          .catch(err => {
            // console.log(err.response);
            this.clicked = false;
            this.msg = err.response.data;
          });
      } else this.msg = "Enter User name and password";
    },
  },
};
</script>
